<script>
export default {
  computed: {
    about() {
      return this.siteData ? Object.keys(this.siteData)?.reduce((acc, key) => {
        if (key.startsWith('about')) {
          acc[key.slice(6)] = this.siteData?.[key]
        }
        return acc
      }, {}) : null
    }
  }
}
</script>

<template>
  <section id="about">
    <v-container :fluid="isMiniPc">
      <v-row align="center" justify="center">
        <v-col cols="12" md="7">
          <h1 class="font-weight-light display-2" v-html="about?.title" />
          <h1 class="font-weight-light display-1 mb-3" v-html="about?.subtitle" />
          <div v-html="about?.content"></div>
        </v-col>
        <v-col cols="12" md="5" class="d-none d-md-flex">
          <v-img
            src="@/assets/img/ill1.svg"
            class="d-block ml-auto mr-auto"
            max-width="400px"
          />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>